export default __webpack_public_path__ + "static/media/catinder-03.f46854d1.png";